<template>
 <div class="cardSlider">
    <slick
      ref="slick"
      :options="slickOptions">
        <collection-card class="slide" v-for="(collection, index) in data" :key="index" :img="collection.img" :title="collection.title" :description="collection.description" :price="collection.price" :link="linkBuilder(collection.id)" />
    </slick>
    <div class="card__wrapper">
      <div class="card__wrapper--overflow">
        <div class="before"></div>
        <collection-card v-for="(collection, index) in data" :key="index" :img="collection.img" :title="collection.title" :description="collection.description" :price="collection.price" :link="linkBuilder(collection.id)" :style="{width: getWidth(), minWidth: getWidth()}" />
        <div class="after"></div>
      </div>
    </div>
 </div>
</template>

<script>
import CollectionCard from '@/components/Card/CollectionCard'
import GridCard from '@/components/Grid/Card'
import Slick from 'vue-slick'
import Media from 'vue-media'

export default {
  name: 'adx-card-slider',
  props: {
    data: {
      required: true
    },
    slide: {
      required: true
    },
    slidelg: {
      required: false
    },
    slidermd: {
      required: false
    },
    slideMobile: {
      required: true
    }
  },
  components: {
    'collection-card': CollectionCard,
    'grid-card': GridCard,
    'slick': Slick,
    'media': Media
  },
  data() {
    return {
      slickOptions: {
        slidesToShow: this.slide,
        slidesToScroll: 1,
        infinite: false,
        nextArrow: '<button type="button" style="' +
                  'top:32%; width:32px; height:32px; position:absolute; right:-16px;"' +
                  'aria-disabled="false"><i class="icon-chevronright"></i></button>',
        prevArrow: '<button type="button" style="' +
                  'top:32%; width:32px; height:32px; position:absolute; left:-16px;"' +
                  'aria-disabled="false"><i class="icon-chevronleft"></i></button>',
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: this.slidemd,
              slidesToScroll: 1,
              arrows: true
            }
          },
          {
            breakpoint: 1920,
            settings: {
              slidesToShow: this.slidelg,
              slidesToScroll: 1,
              arrows: true
            }
          }
        ]
      },
    }
  },
  methods: {
    getWidth() {
      return `${(100 - 15) / this.slideMobile}%`
    },
    linkBuilder(id) {
      return id ? `/collection/detail/${id}/` : `/`
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang="scss">
.cardSlider {
  // .slick-list {
  //   margin: 0 -8px;
  // }
}
</style>
